/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: "I",
      bg: true,
    },
    spendingId: {
      value: 12,
      bg: true,
    },
    arise: {
      value: 0,
      bg: true,
    },
    accumulation: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng doanh thu [12]=[13]+[14]+[15]",
      bg: true,
    },
  },
  {
    bold: false,
    id: {
      value: "1",
      bg: false,
    },
    spendingId: {
      value: 13,
      bg: false,
    },
    arise: {
      value: 0,
      bg: false,
    },
    accumulation: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu bán vé hành khách",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "2",
      bg: false,
    },
    spendingId: {
      value: 14,
      bg: false,
    },
    arise: {
      value: 0,
      bg: false,
    },
    accumulation: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu bán vận đơn hàng không",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "3",
      bg: false,
    },
    spendingId: {
      value: 15,
      bg: false,
    },
    arise: {
      value: 0,
      bg: false,
    },
    accumulation: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu khác",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "II",
      bg: true,
    },
    spendingId: {
      value: 16,
      bg: true,
    },
    arise: {
      value: 0,
      bg: true,
    },
    accumulation: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Các khoản giảm trừ doanh thu [16]=[17]+[18]",
      bg: true,
    },
  },
  {
    bold: false,
    id: {
      value: "1",
      bg: false,
    },
    spendingId: {
      value: 17,
      bg: false,
    },
    arise: {
      value: 0,
      bg: false,
    },
    accumulation: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Các khoản thu hộ",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "2",
      bg: false,
    },
    spendingId: {
      value: 18,
      bg: false,
    },
    arise: {
      value: 0,
      bg: false,
    },
    accumulation: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Chi hoản do khách hàng trả lại vé",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "III",
      bg: true,
    },
    spendingId: {
      value: 19,
      bg: true,
    },
    arise: {
      value: 0,
      bg: true,
    },
    accumulation: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Doanh thu chịu thuế TNDN [19]=[12]-[16]",
      bg: true,
    },
  },
  {
    bold: false,
    id: {
      value: "IV",
      bg: false,
    },
    spendingId: {
      value: 20,
      bg: false,
    },
    arise: {
      value: "0.00",
      bg: false,
    },
    accumulation: {
      value: "0.00",
      bg: true,
    },
    title: {
      value: "Tỷ lệ (%) thuế TNDN tính trên doanh thu chịu thuế",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "V",
      bg: true,
    },
    spendingId: {
      value: 21,
      bg: true,
    },
    arise: {
      value: 0,
      bg: true,
    },
    accumulation: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Thuế TNDN phát sinh trong kỳ [21]=[19]x[20]",
      bg: true,
    },
  },
  {
    bold: false,
    id: {
      value: "VI",
      bg: false,
    },
    spendingId: {
      value: 22,
      bg: false,
    },
    arise: {
      value: 0,
      bg: false,
    },
    accumulation: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế TNDN miễn,giảm theo Hiệp định trong kỳ",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "VII",
      bg: true,
    },
    spendingId: {
      value: 23,
      bg: true,
    },
    arise: {
      value: 0,
      bg: true,
    },
    accumulation: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế TNDN phải nộp trong kỳ [23]=[21]-[22]",
      bg: true,
    },
  },
];

export default function TaxPersonalTable({setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.spendingId.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
      <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
        <table style={tableStyle}>
          <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số phát sinh tháng này</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số luỹ kế năm</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.spendingId.value}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.id.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.id.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.spendingId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    [{row.spendingId.value}]
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.arise.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.arise.bg ? (
                      row.arise.value
                    ) : (
                      <InputTable
                        id={row.spendingId.value}
                        name="arise"
                        value={row.arise.value}
                        onChange={handleChange}
                        type= {row.spendingId.value == 20 ? "decimal" : "number"}

                      />
                    )}
                  </Td> 
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.accumulation.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.accumulation.bg ? (
                      row.accumulation.value
                    ) : (
                      <InputTable
                        id={row.spendingId.value}
                        name="accumulation"
                        value={row.accumulation.value}
                        onChange={handleChange}
                        type= {row.spendingId.value == 20 ? "decimal" : "number"}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        </Box>
        <Box mt={5}>
          <Typography variant="h4" textTransform="uppercase">
            Ghi chú:
          </Typography>
          <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
            Đối với trường hợp khai cho nhiều hãng hàng không nước ngoài thì nhập đại diện thông tin của 1 hãng có doanh thu lớn nhất nhập vào chỉ tiêu [04], [05], [06]
          </Typography>
          
        </Box>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
